const general_helper = {
    isMobile(){
        return /Mobile/.test(navigator.userAgent);
    }
}

export default general_helper